import { privateRequest, publicRequest } from "../axios";

export const syncLanguagesAPI = async () => {
  try {
    const response = await privateRequest.post(`/programming-language/sync`, {});
    return response.data;
  } catch (error) {
    console.error("API Error in syncLanguagesAPI:", error);
    throw error;
  }
};

export const fetchLanguagesAPI = async (pageNo: number = 0, perPage: number = 20, search: string = "") => {
  try {
    const response = await publicRequest.get(`/programming-languages`, {
      params: { pageNo, perPage, search },
    });
    return response.data;
  } catch (error) {
    console.error("API Error in fetchLanguagesAPI:", error);
    throw error;
  }
};
